import React from 'react'

const DashboardLayoutEditContext = React.createContext(false)

export function DashboardLayoutEditProvider({
  value,
  children,
}: {
  value: boolean
  children: React.ReactNode
}): React.ReactElement {
  return (
    <DashboardLayoutEditContext.Provider value={value}>
      {children}
    </DashboardLayoutEditContext.Provider>
  )
}

export function useDashboardLayoutEdit(): boolean {
  return React.useContext(DashboardLayoutEditContext)
}
